import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Car,
  CalendarDays,
  Briefcase,
  CalendarCheck,
  Clock,
} from "lucide-react";

const ReceiverTripsProgressNegotiations = ({
  tripsNegotiations,
  loadingTripsNegotiations,
  onOpenReceiverConfirmModal,
  onOpenPhotosOrderModal,
  onOpenChatModal,
  onOpenModalConfirmReceiptOrder,
}) => {
  const navigate = useNavigate();
  const [visibleNegotiations, setVisibleNegotiations] = useState(2);

  const allowedStatuses = ["4", "5", "6", "7"];

  const filteredNegotiations = tripsNegotiations.filter((item) =>
    allowedStatuses.includes(item.trip_status),
  );

  const handleShowMoreTripsNegotiations = () => {
    setVisibleNegotiations((prev) => prev + 2);
  };

  if (loadingTripsNegotiations) {
    return <p>Carregando negociações...</p>;
  }

  return (
    <>
      {filteredNegotiations.length > 0 && (
        <div className="search-top viagens-disponibilizadas">
          <span className="recommended">⭐ Viagens em Negociação</span>
        </div>
      )}

      {filteredNegotiations.slice(0, visibleNegotiations).map((item) => (
        <div className="container-travel-card" key={item.id}>
          <div className="profile-box profile-box-travel-card">
            <img
              src={item.traveler?.imagem || "https://i.pravatar.cc/100"}
              alt="perfil"
              className="profile-image"
            />

            <h3 style={{ marginTop: 5 }}>{item.traveler?.nome}</h3>

            <br />
          </div>

          <div className="info-box">
            <div className="route-tags-row">
              <div className="route-container">
                <div className="location-badge">{item.trip?.cidade_origem}</div>

                <div className="icon-box">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#1cb5e0"
                    strokeWidth="3"
                  >
                    <path d="M7 7l10 10M17 7v10H7" />
                  </svg>
                </div>

                <div className="location-badge">
                  {item.trip?.cidade_destino}
                </div>
              </div>

              <div className="tags">
                <div className="tags-row">
                  <span className="tag-item">
                    <Car size={16} strokeWidth={2.5} className="tag-icon" />
                    {item.trip?.meio_transporte}
                  </span>

                  <span className="tag-item">
                    <CalendarDays
                      size={16}
                      strokeWidth={2.5}
                      className="tag-icon"
                    />
                    {item.trip?.duracao_viagem}
                  </span>
                </div>

                <span className="tag-item">
                  <Briefcase size={16} strokeWidth={2.5} className="tag-icon" />
                  {item.client_order_type}
                </span>
              </div>
            </div>

            <div className="dates">
              <div className="date-group">
                <small>SAÍDA</small>
                <div className="date-content">
                  <CalendarCheck size={13} className="blue-icon" />
                  <span className="date-text">
                    {item.trip?.data_partida} às
                  </span>
                  <div className="time-badge">
                    <span>{item.trip?.horas_partida || "-"}</span>
                  </div>
                </div>
              </div>

              <div className="date-group">
                <small>CHEGADA</small>
                <div className="date-content">
                  <CalendarCheck size={13} className="blue-icon" />
                  <span className="date-text">
                    {item.trip?.data_chegada || "-"} às
                  </span>
                  <div className="time-badge">
                    <span>{item.trip?.horas_chegada || "-"}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container-travel-btns">
            <div className={`status-badge status-${item.trip_status}`}>
              {item.trip_status === "4" ||
              item.is_receiver_data_confirmed == false
                ? "Aguardando sua disponibilidade para receber a encomenda"
                : item.trip_status === "5" &&
                    item.is_receiver_data_confirmed == true
                  ? "Aguardando as fotografias da encomenda"
                  : item.trip_status === "6" &&
                      item.is_receiver_data_confirmed == true
                    ? "Aguardando as fotografias da encomenda"
                    : item.trip_status === "7" &&
                        item.is_receiver_data_confirmed == true
                      ? "Acompanhe a encomenda até o seu destino"
                      : "Status indisponível"}
            </div>

            <div className="travel-actions">
              {item.trip_status === "4" ||
              item.is_receiver_data_confirmed == false ? (
                <>
                  <button
                    className="action-btn ghost"
                    onClick={() => onOpenReceiverConfirmModal(item, "confirm")}
                  >
                    Confirmar Disponibilidade
                  </button>

                  <button
                    className="action-btn ghost"
                    onClick={() => onOpenReceiverConfirmModal(item, "refuse")}
                  >
                    Recusar Disponibilidade
                  </button>
                </>
              ) : null}

              {item.trip_status === "5" &&
                item.is_receiver_data_confirmed == true && (
                  <>
                    <button
                      className="action-btn ghost"
                      onClick={() => onOpenChatModal(item, "receiver")}
                    >
                      Chat
                    </button>
                  </>
                )}

              {item.trip_status === "6" &&
                item.is_receiver_data_confirmed == true && (
                  <>
                    <button
                      className="action-btn ghost"
                      onClick={() => onOpenChatModal(item, "receiver")}
                    >
                      Chat
                    </button>
                  </>
                )}

              {item.trip_status === "7" &&
                item.is_receiver_data_confirmed == true && (
                  <>
                    <button
                      className="action-btn ghost"
                      onClick={() => {
                        navigate("/trip-tracking-receiver", {
                          state: { item, from: "dashboard" },
                        });
                      }}
                    >
                      Acompanhar Encomenda
                    </button>
                    <button
                      className="action-btn ghost"
                      onClick={() => onOpenModalConfirmReceiptOrder(item)}
                    >
                      Confirmar recebimento
                    </button>
                    <button
                      className="action-btn ghost"
                      onClick={() => onOpenChatModal(item, "receiver")}
                    >
                      Chat
                    </button>
                    <button
                      className="action-btn ghost"
                      onClick={() => onOpenPhotosOrderModal(item, "upload")}
                    >
                      Verificar as fotografias
                    </button>
                  </>
                )}
            </div>
          </div>

          <div className="description-travel">
            {item.trip?.informacao_sobre_trajeto || "Sem descrição"}
          </div>
        </div>
      ))}

      {visibleNegotiations < filteredNegotiations.length && (
        <div className="show-more-container">
          <button
            className="show-more-btn"
            onClick={handleShowMoreTripsNegotiations}
          >
            Exibir mais viagens
          </button>
        </div>
      )}
    </>
  );
};

export default ReceiverTripsProgressNegotiations;
